import { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Alert,
} from '@mui/material';
import { AppPage } from '../../components/design-system';
import {
  Flag as FlagIcon,
  VpnKey as VpnKeyIcon,
} from '@mui/icons-material';
import type { ReactElement } from 'react';
import { useProviderSettings } from '../../contexts/ProviderSettingsContext';
import FeatureFlags from './tabs/FeatureFlags';
import EncryptionKeys from './tabs/EncryptionKeys';

interface TabConfig {
  label: string;
  icon: ReactElement;
  component: ReactElement;
}

export default function SystemConfiguration() {
  const [activeTab, setActiveTab] = useState(0);
  const { flagsError } = useProviderSettings();

  const tabs: TabConfig[] = [
    {
      label: 'Feature Flags',
      icon: <FlagIcon />,
      component: <FeatureFlags />,
    },
    {
      label: 'Encryption Keys',
      icon: <VpnKeyIcon />,
      component: <EncryptionKeys />,
    },
  ];

  return (
    <AppPage sx={{ flex: 1, minHeight: 0 }}>
      {flagsError && (
        <Alert severity="error" sx={{ flexShrink: 0 }}>
          {flagsError}
        </Alert>
      )}

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(_event, newValue: number) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            flexShrink: 0,
            borderBottom: 1,
            borderColor: 'divider',
            px: 1,
            '& .MuiTab-root': {
              minHeight: 56,
              textTransform: 'none',
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              icon={tab.icon}
              iconPosition="start"
            />
          ))}
        </Tabs>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            bgcolor: 'background.default',
          }}
        >
          {tabs[activeTab]?.component}
        </Box>
      </Box>
    </AppPage>
  );
}
